import { Pencil, Trash2 } from "lucide-react";
import { CREDENTIAL_SECRET_TYPE_LABELS, type CredEntry } from "../api/credentials";

type CredentialCardGridProps = {
  entries: CredEntry[];
  sourceNameMap: Record<string, string>;
  saving: string | null;
  onEdit: (source: string, secretTypes: string[]) => void;
  onDelete: (source: string) => void;
};

const CredentialCardGrid = ({
  entries,
  sourceNameMap,
  saving,
  onEdit,
  onDelete,
}: CredentialCardGridProps) =>
  entries.length === 0 ? null : (
    <div className="creds-grid">
      {entries.map((entry) => (
        <div key={entry.source} className="creds-card has-creds">
            <div className="creds-card-header">
            <div className="creds-card-name" title={sourceNameMap[entry.source] ?? entry.source}>
              <strong>{sourceNameMap[entry.source] ?? entry.source}</strong>
              {sourceNameMap[entry.source] && (
                <span className="creds-card-code">{entry.source}</span>
              )}
            </div>
            <div className="creds-card-actions">
              <button
                className="creds-edit-btn"
                title="Edit"
                onClick={() => onEdit(entry.source, entry.secret_types)}
              >
                <Pencil size={14} />
              </button>
              <button
                className="creds-delete-btn"
                title="Remove"
                onClick={() => onDelete(entry.source)}
                disabled={saving === entry.source}
              >
                <Trash2 size={14} />
              </button>
            </div>
          </div>
          <div className="creds-card-fields">
            {entry.secret_types.map((t) => (
              <div key={t} className="creds-field-row">
                <span className="creds-field-key">
                  {CREDENTIAL_SECRET_TYPE_LABELS[t] ?? t}
                </span>
                <span className="creds-field-value">{entry.value_hints?.[t] ?? '••••••••'}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

export default CredentialCardGrid;
